import urlLocationHelper from '@/scripts/helpers/url-location-helper';
import { Model } from '@viddsee/server-api-client';
import { BaseCollectionImplementationIdentifierValue } from './videoCollections/implementations/core/helpers';

export interface VideoInfoCompat extends Model.Video.Info {
  url: string;
  imageUrl: string;
}

export class VideoCollectionVideo {
  constructor(
    public video: Model.Video.Info,
    public collectionIdentifierValues: BaseCollectionImplementationIdentifierValue[] = [],
  ) {}

  get id(): string {
    return this.video.id;
  }

  get title(): string {
    return this.video.title;
  }

  get url(): string {
    const videoPageUrl = (`/video/${this.video.slug}/${this.video.id}`);
    const videoCollectionVideoQueryString = urlLocationHelper.query.encode(
      this.collectionIdentifierValues.reduce((acc, { ids, value }) => ({
        ...acc,
        [ids.queryId]: value,
      }), {}),
    );

    return videoPageUrl + videoCollectionVideoQueryString;
  }

  get imageUrl(): string {
    return this.video.photoSmallUrl;
  }

  getAttributes(): VideoInfoCompat {
    return {
      ...this.video,
      id: this.id,
      title: this.title,
      url: this.url,
      imageUrl: this.imageUrl,
    };
  }
}
